// ヘッダー ⚙ から開く API 設定ポップオーバー。
// PortWatch API はキー不要なので、Claude APIキー / モデル / max_tokens のみ。

function ApiSettings({
  apiKey,
  model,
  maxTokens,
  toolWebSearch,
  isOpen,
  onToggle,
  onApiKeyChange,
  onModelChange,
  onMaxTokensChange,
  onToolWebSearchChange,
  onSave,
  onDeleteKey,
}) {
  const handleSubmit = (event) => {
    event.preventDefault();
    onSave();
  };

  return (
    <div className="settings">
      <button className="ghost-button" type="button" onClick={onToggle}>
        ⚙ API設定
      </button>

      {isOpen && (
        <form
          className="settings-popover"
          aria-label="API設定"
          onSubmit={handleSubmit}
        >
          <label htmlFor="claude-api-key">Claude APIキー</label>
          <input
            id="claude-api-key"
            type="password"
            value={apiKey}
            placeholder="sk-ant-..."
            autoComplete="off"
            onChange={(event) => onApiKeyChange(event.target.value)}
          />
          <p className="field-help">
            APIキーは
            <a
              href="https://platform.claude.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              platform.claude.com
            </a>
            で取得できます。
          </p>

          <label htmlFor="claude-model">Claudeモデル</label>
          <input
            id="claude-model"
            type="text"
            value={model}
            onChange={(event) => onModelChange(event.target.value)}
          />

          <label htmlFor="claude-max-tokens">最大出力トークン (max_tokens)</label>
          <input
            id="claude-max-tokens"
            type="number"
            min="1"
            value={maxTokens}
            onChange={(event) =>
              onMaxTokensChange(Number(event.target.value) || 0)
            }
          />
          <p className="field-help">
            回答が途中で切れる場合は大きくします（推奨16000）。
          </p>

          <fieldset className="settings-tools">
            <legend>サーバー側ツール</legend>
            <p className="field-help tools-note">
              Anthropic 側で実行されるツールです（別途課金）。
            </p>
            <label className="checkbox-row">
              <input
                type="checkbox"
                checked={toolWebSearch}
                onChange={(event) => onToolWebSearchChange(event.target.checked)}
              />
              Web検索
            </label>
            <p className="field-help checkbox-help">
              有効にすると、エージェントが最新情報を web から取得できます
              （ニュース・直近のイベント等）。
            </p>
          </fieldset>

          <div className="settings-actions">
            <button type="submit" className="primary-button">
              保存して閉じる
            </button>
            <button
              type="button"
              className="ghost-button"
              onClick={onDeleteKey}
              disabled={!apiKey}
            >
              キーを削除
            </button>
          </div>

          <p className="field-help">
            Claude APIキーはこのブラウザの localStorage に保存され、リロード後も
            復元されます。PortWatch のデータ取得にキーは不要です。共有端末では
            使用後に必ず削除してください。
          </p>
        </form>
      )}
    </div>
  );
}

export default ApiSettings;
